import { getChannelAPIPath } from '@treasury/core/http';

TermsAndConditionsService.$inject = ['$resource', '$http', '$q'];

export default function TermsAndConditionsService($resource, $http, $q) {
    return {
        get,
        accept,
    };

    function get(blankIfUserAccepted) {
        return $resource(`${getChannelAPIPath()}termsAndConditions/`).get({
            blankIfUserAccepted: blankIfUserAccepted || false,
        }).$promise;
    }

    function accept() {
        return $resource(`${getChannelAPIPath()}termsAndConditions/accept`).get().$promise;
    }
}
